export default class MyCookies{
  /**
   * 设置cookie
   * @param {*} cname 
   * @param {*} cvalue 
   * @param {*} exdays 
   * @param {*} path 
   */
  static setCookie(cname,cvalue,hours,path){
    var d = new Date();
    d.setTime(d.getTime() + (hours  * 60 * 60 * 1000));
    var expires = "expires =" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";" + 'path=' + path;
  }
  /**
   * 获取cookie信息
   * @param {*} cname 
   */
  static getCookie (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) === 0) {
          return c.substring(name.length,c.length);
        }
    }
    return "";
  }
  /**
   * 检查cookie用户信息
   */
  static checkCookie () {
    var user = MyCookies.getCookie("user_info");
    if (user !== ""){
      return true
    }
    else {
      return false
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/my_cookies.js